import { CSSProperties, FC, ReactNode } from "react";
import { clsx } from "clsx";
import classes from "./Metrics.module.less";

export interface Metric {
    label: string;
    value: ReactNode;
    /** The number's color: the default blue, or a score's green, orange or red. */
    color?: "blue" | "green" | "orange" | "red";
    /** A second number after "of", in the default blue: what the first is a part of. */
    secondary?: ReactNode;
    /** A line under the number: what it is of, or how it moved. */
    detail?: ReactNode;
}

interface MetricsProps {
    metrics: Metric[];
    style?: CSSProperties;
}

/** The vendor page's banner of headline numbers, styled like the dashboard's. */
export const Metrics: FC<MetricsProps> = ({ metrics, style }) => (
    <div className={classes.container} style={style}>
        {metrics.map((item) => (
            <div className={classes.metric} key={item.label}>
                <div className={classes.label}>{item.label}</div>
                <div className={clsx(classes.value, item.color && classes[`value--${item.color}`])}>
                    {item.value}
                    {item.secondary != null && <span className={classes.secondary}> of {item.secondary}</span>}
                </div>
                {item.detail && <div className={classes.detail}>{item.detail}</div>}
            </div>
        ))}
    </div>
);
